import type { MultipleMaintainerProps, SingleMaintainerProps } from '../types';

const EMPTY: string[] = []; // for preventing re-renders

export const getSelectedValues = (props: SingleMaintainerProps | MultipleMaintainerProps) => {
  const { selectionMode } = props;
  // Extract the appropriate IDs based on selectionMode
  const maintainerId = selectionMode === 'single' ? props.maintainerId : undefined;
  const maintainerTeamKey = selectionMode === 'single' ? props.maintainerTeamKey : undefined;
  const maintainerIds = selectionMode === 'multiple' ? (props.maintainerIds ?? EMPTY) : EMPTY;
  const maintainerTeamKeys = selectionMode === 'multiple' ? (props.maintainerTeamKeys ?? EMPTY) : EMPTY;

  return { maintainerId, maintainerTeamKey, maintainerIds, maintainerTeamKeys };
};
